﻿/*
 * @class rlRichText
 */
(function ($) {
   $.fn.rlRichText = function () {
      ///detect if rich text container area IS EMPTY
      const richTextContent = document.querySelectorAll('.richtextcontainerblock .contentarea'),
         richTextArea = document.querySelectorAll('.richtextcontainerblock .richtextarea');

      for (let i = 0; i < richTextContent.length; i++) {
         if (richTextContent[i].children.length === 0) {
            richTextContent[i].classList.add('empty');
            richTextArea[i].classList.add('emptycontentarea');
         }
      }
      ///Class identify the last element in the rich text area
      for (let j = 0; j < richTextArea.length; j++) {
         if (richTextArea[j].lastElementChild) {
            richTextArea[j].lastElementChild.classList.add('lastchild');
         }
      }

   }
}(jQuery));